import React, { useContext } from 'react'
import { ConfigProvider, BannerCarousel } from '@ntuctech/tangram-web'
import { EventTrackingContext } from '../../components/EventTrackingProvider/EventTrackingProvider'
import { GTM_ENV_VAR as GEV } from '../../lib/eventTrackerFunction'
import { getCtaLocationMeta } from '../../lib/utils'
import { getPageTypeByUrl } from '../../lib/amplitude'
import tangramNextConfig from '../../lib/tangramNextConfig'
import { trackBannerClickedEvent } from '../../lib/analytics/events/banner/BannerClickedEvent'
import { createBannerClickedEventParams } from '../../lib/analytics/utils/Banner/BannerEventHelper'

const BannerCarouselWrapper = ({ imageList, storeType }) => {
  const { track } = useContext(EventTrackingContext)

  const handleBannerClick = id => {
    const { imageUrl, link } = imageList[id]
    track({
      [GEV.AMPLITUDE_EVENT_NAME]: 'banner clicked',
      [GEV.AMPLITUDE_VERTICAL]: 'grocery-online',
      [GEV.SEGMENT_SCREEN_CATEGORY]: 'grocery-online',
      [GEV.AMPLITUDE_CTA_LOCATION]: {
        pageName: getPageTypeByUrl(),
        pageMeta: getCtaLocationMeta() || [],
      },
      [GEV.AMPLITUDE_CTA_SUBLOCATION]: null,
      [GEV.AMPLITUDE_BANNER_ID]: imageUrl,
      [GEV.AMPLITUDE_BANNER_NAME]: imageUrl,
      [GEV.AMPLITUDE_BANNER_POSITION]: id,
      [GEV.AMPLITUDE_BANNER_TYPE]: 'BIG',
      [GEV.SEGMENT_STORE_TYPE]: storeType,
      [GEV.AMPLITUDE_BANNER_DESTINATION_LINK]: link,
    })

    trackBannerClickedEvent(
      createBannerClickedEventParams({
        name: imageUrl,
        link,
        imageUrl,
        bannerType: 'BIG',
        position: id,
      })
    )
  }
  return (
    <ConfigProvider
      tokens={tangramNextConfig}
      experimental={{
        BannerCarousel: true,
      }}
    >
      <BannerCarousel
        images={imageList}
        onBannerClick={handleBannerClick}
        rotationInterval={6000}
      />
    </ConfigProvider>
  )
}

export default BannerCarouselWrapper
